import apiService from './apiService';

// Outbound send AS one of our SES-inbound-forwarder addresses, and
// management of the forwarder Lambdas' target lists. Mirrors
// api/routers/admin_forward_mail.py.

export interface SendRequest {
  from_local_part: string;
  from_domain: string;
  from_display?: string | null;
  to: string;                 // comma/semicolon/newline-separated
  cc?: string | null;
  bcc?: string | null;
  reply_to?: string | null;
  subject: string;
  body_text?: string | null;
  body_html?: string | null;
}

export interface SendResponse {
  message_id: string | null;
  from: string;
  to: string[];
  cc: string[];
  bcc: string[];
}

export interface ForwarderTargets {
  function_name: string;
  label: string;
  recipients: string[];
  to: string[];
  cc: string[];
  bcc: string[];
  last_modified: string | null;
}

export interface TargetsUpdateRequest {
  to: string;
  cc?: string | null;
  bcc?: string | null;
}

export const forwardMailApi = {
  listDomains: () =>
    apiService
      .get<{ domains: string[] }>('/api/admin/forward-mail/domains')
      .then(r => r.data),
  send: (payload: SendRequest) =>
    apiService
      .post<SendResponse>('/api/admin/forward-mail/send', payload)
      .then(r => r.data),
  listForwarders: () =>
    apiService
      .get<{ forwarders: ForwarderTargets[] }>('/api/admin/forward-mail/forwarders')
      .then(r => r.data),
  updateForwarder: (functionName: string, payload: TargetsUpdateRequest) =>
    apiService
      .put<ForwarderTargets>(
        `/api/admin/forward-mail/forwarders/${encodeURIComponent(functionName)}`,
        payload,
      )
      .then(r => r.data),
};
